import React from "react";

import { IconDashboard } from "~/components/icon";

import { type UserProfile, useUserProfile } from "../../../common/use-user-profile";
import { useNavigateToLink } from "../../../components/react/link";
import { queryAllDashboards } from "../../../queries/dashboards";
import { useQuery } from "../../../queries/react-query";
import { DASHBOARDS_OVERVIEW_PATH } from "../../../routes/Routes";
import { MainMenuItemLayout } from "../MainMenuItemLayout";

import { DashboardMenuItemView } from "./DashboardMenuItemView";
import { DashboardMenuOverviewItem } from "./DashboardMenuOverviewItem";

export const DashboardMenu: React.FC = () => {
	const { data: allDashboards } = useQuery(queryAllDashboards);

	const [starredDashboards] = useUserProfile({
		select: React.useCallback(
			({ starredDashboards: usersStarredDashboards }: UserProfile) =>
				allDashboards?.filter((dashboard) => usersStarredDashboards.has(dashboard.id)),
			[allDashboards],
		),
	});

	const linkToOverview = useNavigateToLink(DASHBOARDS_OVERVIEW_PATH, {
		search: ["timeRange", "timestamp", "detachedFilters"],
	});

	return (
		<MainMenuItemLayout
			data-trackid=""
			defaultOpen={starredDashboards && starredDashboards.length > 0}
			icon={<IconDashboard className="text-grey-800" height={18} width={18} />}
			label="Dashboards"
			to={linkToOverview}
		>
			<DashboardMenuOverviewItem dashboardsCount={allDashboards?.length} />

			{starredDashboards && starredDashboards.length > 0 && (
				<div className="mt-3">
					{starredDashboards.map((dashboard) => (
						<DashboardMenuItemView dashboard={dashboard} key={dashboard.id} />
					))}
				</div>
			)}
		</MainMenuItemLayout>
	);
};
